import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";

import cover from "../assets/img/sub_treasure.png";


export const projectDetails: ProjectInterface = {
    url: "sub",
    title: "S.U.B.",
    summary: 'A simple "get the treasure" game to familiarize with Phaser framework',
    description: `At the time I was still in web development and wanted to make a game.

It wasn't my first contact with gamedev but it was where I started considering that path. I choose something really simple so I could get familiarized with the framework I was using (Phaser.js). It was a very nice experience and making the sprites myself added to it. 😇`,
    year: "2021",
    tags: ["Action", "Arcade", "Web", "Phaser.js"],
    imageSrc: cover,
    hasVideo: false,
    startVideoTime: 0,
    videoSrc: "",
    isCoverType: true,
    haveTags: true,
    projectType: ProjectType.PERSONAL,
    roles: ["Programmer", "Artist"],
    technologies: ["Web", "Phaser.js"],
    collaborators: ["Lucas Coutinho"],
    highlightColor: "#60151F",
    descriptionTitle: "My “let’s try game dev” moment",
    linkData:
        [
            { type: 'github', url: "https://github.com/lucasctnh/sub-treasure-hunter" },
            { type: 'text', url: "https://treasure-hunter-game-sub.web.app/" },
        ],
    relatedProjects: ["Run01", "StreetRacing", "CheckMore"],
};


export function SUB() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={false}
                leftContent={
                    <div className="a-left-frame-no-bg">
                        <div className="a-left-frame-inside-no-bg" style={{ width: "820px" }}>
                            <iframe className="a-frame" src="https://treasure-hunter-game-sub.web.app/" style={{ height: "622px" }} allow="gamepad *;" title="S.U.B."></iframe>
                        </div>
                    </div>
                }
                rightContent={
                    null
                }>
            </ProjectBase>
        </div>
    );
}